import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { Map } from '../_models/abstract-map.model';

let urls: Map = {
  /** User */
  login: '/users/auth/basic/totem',
  reset_password: '/users/auth/reset-password',
  current_user: '/users/me',
  user_register: '/users',
  google_login: '/users/gauth',
  wallets: '/users/me/wallets',
  user_check_emai: '/users/auth/check-email',
  user_cards: '/users/me/cards',
  card_delete: '/cards/{card_id}',
  login_beneficiary: '/beneficiaries/sites/{site_id}/stores/{store_id}/extra',
  customer_wallet: '/users/{user_id}/wallet-info',
  
  /** Sitio */
  site_by_id: '/sites/{site_id}',
  /** Totem */
  totem_by_id: '/sites/{site_id}/totems/{totem_id}',

  /** Comercio */
  store_by_id: '/stores/{store_id}',
  stores_by_site_id: '/sites/{site_id}/stores',
  store_validation_coupon: '/stores/{store_id}/coupon',
  /** MENU */
  menu_by_store_id: '/stores/{store_id}/menu',
  item_by_id_and_store_id: '/stores/{store_id}/product/{id}',
  menu_by_site_id: '/sites/{site_id}/stores/products',
  menu_recomendations_by_site_id:
    '/sites/{site_id}/stores/products/recomendations',
  shopping_cart: '/stores/{store_id}/product/{item_id}/cart',
  menu_categories_by_store_id: '/stores/{store_id}/categories',
  clear_shopping_cart_cloud: '/orders/totem/{totem_id}/delete/cart/{cart_id}',
  delete_shopping_cart_cloud_item: '/orders/cart/{cart_id}/product/{item_index}/totem',

  /** Ordenes */
  order_create: '/orders/totem',
  orders: '/users/me/orders/historial',
  orders_active: '/users/me/orders/active',
  order_by_id: '/users/me/orders/{order_id}',
  order_group_create: '/orders/group',
  order_group_by_id: '/users/me/orders/group/{order_id}',
  order_payment_retry: '/orders/payment/{order_id}/retry',
  order_payment_getnet: '/orders/totem/{order_id}/getnet-payment',
  order_payment_getnet_update: '/orders/totem/{order_id}/getnet/order-update',
  order_update_print: '/orders/{order_id}/totem/printer',
  /** Banners */
  banner_by_id: '/banners/{banners_id}',
  banners: '/banners/all',
  /** Surveys */
  surveys: '/surveys/pending/{order_id}',
  surveys_omitted: '/surveys/{survey_id}/omitted',
  surveys_canceled: '/surveys/{survey_id}/canceled',
  surveys_asnwer: '/surveys/{survey_id}/asnwer',
  /** In apps */
  inapp: '/communications/inapp',
  inapp_read: '/communications/{communication_id}/read',
};

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  constructor() {}

  getUrl(route: string, url_params: Map = {}, isAdmin: boolean = false) {
    const urlApiBase = isAdmin
      ? environment.api_admin_url
      : environment.api_url;
    var url = urlApiBase + urls[route];
    for (var key in url_params) {
      if (url.search(key) > -1) {
        url = url.replace('{' + key + '}', url_params[key]);
      }
    }
    return url;
  }

  getQueryString(params: Map = {}) {
    if (params != undefined || Object.keys(params).length > 0) {
      let querystring = new HttpParams();
      for (let key in params) {
        if (![undefined].includes(params[key])) {
          querystring = querystring.set(key, params[key]);
        }
      }
      return querystring;
    }

    return new HttpParams();
  }

  getHeaders(headers: Map | undefined = undefined) {
    if (headers != undefined && Object.keys(headers).length > 0) {
      return new HttpHeaders(headers);
    }
    return new HttpHeaders();
  }
}
